// extracted by mini-css-extract-plugin
module.exports = {"complaints-form":"complaints-form_complaints-form__5BfMk","field-row":"complaints-form_field-row___mwwm","input-row":"complaints-form_input-row__nP5N8"};